// https://www.bezkoder.com/react-refresh-token/

// https://stackoverflow.com/questions/60428490/how-to-trigger-person-click-remember-me-or-not
// this needs to be a function so we reevaluate each time we use!
const getStorage = () => { return localStorage.hasOwnProperty("remember") ? localStorage : sessionStorage }

const getLocalRefreshToken = () => {
    const user = JSON.parse(getStorage().getItem("user") || '{}');
    // console.log("REFRESH TOKEN");
    // console.log(user?.refresh);
    return user?.refresh;
};
const getLocalAccessToken = () => {
    const user = JSON.parse(getStorage().getItem("user") || '{}');
    return user?.access;
};

// https://stackoverflow.com/questions/54715260/typescript-json-parse-error-type-null-is-not-assignable-to-type-string
const updateLocalAccessToken = (token: any) => {
    // should only be called after we set "user" in localStorage based on JWT.
    // so, probably don't have to worry about the case where getItem returns null
    let user = JSON.parse(getStorage().getItem("user") || '{}');
    user.access = token;
    getStorage().setItem("user", JSON.stringify(user));
    return null;
};

// compare with getCurrentUser in auth.ts (changed to match)
const getUser = () => {
    const userStr = getStorage().getItem("user");
    if (userStr) return JSON.parse(userStr);
    return null;
};

const setUser = (user: any) => {
    console.log(JSON.stringify(user));
    getStorage().setItem("user", JSON.stringify(user));
};
const removeUser = () => {
    getStorage().removeItem("user");
};
const TokenService = {
    getLocalRefreshToken,
    getLocalAccessToken,
    updateLocalAccessToken,
    getUser,
    setUser,
    removeUser,
};
export default TokenService;